import Moment from 'moment';
import React from 'react';

export const getDays = () => {
  const listOfDays = [];
  for (let i = 1; i <= 31; i++) {
    listOfDays.push({ key: `day-${i}`, text: `${i}`, value: `${i}` });
  }
  return listOfDays;
};
export const getMonths = [
  { key: 'January', text: 'January', value: '1' },
  { key: 'February', text: 'February', value: '2' },
  { key: 'March', text: 'March', value: '3' },
  { key: 'April', text: 'April', value: '4' },
  { key: 'May', text: 'May', value: '5' },
  { key: 'June', text: 'June', value: '6' },
  { key: 'July', text: 'July', value: '7' },
  { key: 'August', text: 'August', value: '8' },
  { key: 'September', text: 'September', value: '9' },
  { key: 'October', text: 'October', value: '10' },
  { key: 'November', text: 'November', value: '11' },
  { key: 'December', text: 'December', value: '12' },
];
export const getYears = () => {
  const years = [];
  for (let i = Moment().year(); i >= 1915; i--) {
    years.push({ key: `year-${i}`, text: `${i}`, value: `${i}` });
  }
  return years;
};
export const getGenders = [
  { key: 'Female', text: 'Female', value: 'FEMALE' },
  { key: 'Male', text: 'Male', value: 'MALE' },
  { key: 'Prefer Not to Answer', text: 'Prefer Not to Answer', value: 'OTHER' },
];

// to use on the casemanagers sign up screen only
export const getMedications = [
  { key: 'Alunbrig (brigatinib)', text: <React.Fragment>Alunbrig (brigatinib)</React.Fragment>, value: '9a112184-84ba-4e97-8823-c2ab1a11e59c' },
  { key: 'Fruzaqla (fruquintinib)', text: <React.Fragment>Fruzaqla (fruquintinib)</React.Fragment>, value: '5727dfcf-3786-42de-a82c-a7ab5e34274d' },
  { key: 'Iclusig (ponatinib)', text: <React.Fragment>Iclusig (ponatinib)</React.Fragment>, value: 'e10d1932-10da-4967-a70f-42ba1e2c1b7c' },
  { key: 'Ninlaro (ixazomib)', text: <React.Fragment>Ninlaro (ixazomib)</React.Fragment>, value: 'f429786d-dfd2-4ca6-8499-075ad2afdcf2' },
  { key: 'Mimrylo (rusfertide)', text: <React.Fragment>Mimrylo (rusfertide)</React.Fragment>, value: '3a40fa97-a4c1-4b74-a6a3-7fb00cce61d5' },
];
